import React from 'react'
import { useTranslation } from 'react-i18next'
import { SectionShell } from '../shared/SectionShell'
import { SectionHeading } from '../shared/SectionHeading'
import connectCards from '../../data/links.js'

const CARD_ICONS = {
    notion: (
        <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
            <path d="M4.459 4.208c.746.606 1.026.56 2.428.466l13.215-.793c.28 0 .047-.28-.046-.326L17.86 2.028c-.42-.326-.981-.7-2.055-.607L3.01 2.68c-.467.047-.56.28-.374.466l1.823 1.062zm.793 3.08v13.904c0 .747.373 1.027 1.214.98l14.523-.84c.841-.046.935-.56.935-1.167V6.354c0-.606-.233-.933-.748-.887l-15.177.887c-.56.047-.747.327-.747.933zm14.337.745c.093.42 0 .84-.42.888l-.7.14v10.264c-.608.327-1.168.514-1.635.514-.748 0-.935-.234-1.495-.933l-4.577-7.186v6.952L12.21 19s0 .84-1.168.84l-3.222.186c-.093-.186 0-.653.327-.746l.84-.233V9.854L7.822 9.76c-.094-.42.14-1.026.793-1.073l3.456-.233 4.764 7.279v-6.44l-1.215-.14c-.093-.514.28-.887.747-.933l3.222-.187z" />
        </svg>
    ),
    linkedin: (
        <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
            <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
        </svg>
    ),
    github: (
        <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
            <path d="M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61C4.422 18.07 3.633 17.7 3.633 17.7c-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12" />
        </svg>
    ),
    rss: (
        <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M4 11a9 9 0 0 1 9 9" />
            <path d="M4 4a16 16 0 0 1 16 16" />
            <circle cx="5" cy="19" r="1" fill="currentColor" />
        </svg>
    ),
}

export default function ConnectSection() {
    const { t } = useTranslation()

    return (
        <SectionShell id="connect" className="connect-section">
            <div className="connect-planet-backdrop" aria-hidden="true">
                <svg viewBox="0 0 600 600" fill="none" className="connect-planet-svg">
                    <circle cx="300" cy="300" r="280" stroke="currentColor" strokeWidth="0.6" strokeOpacity="0.08" />
                    <circle cx="300" cy="300" r="210" stroke="currentColor" strokeWidth="0.5" strokeOpacity="0.06" />
                    <circle cx="300" cy="300" r="140" stroke="currentColor" strokeWidth="0.4" strokeOpacity="0.05" />
                    <ellipse cx="300" cy="300" rx="380" ry="60" stroke="currentColor" strokeWidth="0.7" strokeOpacity="0.10" />
                </svg>
            </div>

            <SectionHeading label={t('connect.label')} />

            <div className="connect-bento">
                {connectCards.map((card) => (
                    <a
                        key={card.id}
                        href={card.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={`connect-card connect-card--${card.id}`}
                        data-magnetic
                    >
                        <span className="connect-card-icon">
                            {CARD_ICONS[card.icon] || CARD_ICONS.rss}
                        </span>
                        <span className="connect-card-title">{t(card.titleKey)}</span>
                        <p className="connect-card-body">{t(card.bodyKey)}</p>
                        <span className="connect-card-link">
                            {t(card.linkKey)}
                            <svg viewBox="0 0 16 16" width="12" height="12" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                                <line x1="3" y1="8" x2="13" y2="8" />
                                <polyline points="8 3 13 8 8 13" />
                            </svg>
                        </span>
                    </a>
                ))}
                <a
                    href="mailto:admin@itsmyhub.me?subject=Let%27s%20build%20something"
                    className="connect-card connect-card--email"
                    data-magnetic
                >
                    <span className="connect-card-icon">
                        <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                            <rect x="2" y="4" width="20" height="16" rx="2" />
                            <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
                        </svg>
                    </span>
                    <span className="connect-card-title">EMAIL</span>
                    <p className="connect-card-body">admin@itsmyhub.me</p>
                    <span className="connect-card-link">
                        WRITE
                        <svg viewBox="0 0 16 16" width="12" height="12" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                            <line x1="3" y1="8" x2="13" y2="8" />
                            <polyline points="8 3 13 8 8 13" />
                        </svg>
                    </span>
                </a>
            </div>
        </SectionShell>
    )
}
